export default __webpack_public_path__ + "static/media/clientCase8.62ccd875.png";